import React from 'react';
import { dateModes } from '../../../features/commerce/delivery/dates';
import NoDelivery from './NoDelivery';
import SameDay from './SameDay';
import Night from './Night';
import Interval from './Interval';
import DeliverySaturday from './DeliverySaturday';
import DeliverySunday from './DeliverySunday';
import NoNight from './NoNight';
import NoWeekend from './NoWeekend';

export default ({ mode, ...props }) => {
  switch (mode) {
    case dateModes.noDelivery:
      return (
        <NoDelivery {...props} />
      );
    case dateModes.sameDay:
      return (
        <SameDay {...props} />
      );
    case dateModes.night:
      return (
        <Night {...props} />
      );
    case dateModes.interval:
      return (
        <Interval {...props} />
      );
    case dateModes.noNight:
      return (
        <NoNight {...props} />
      );
    case dateModes.noWeekend:
      return (
        <NoWeekend {...props} />
      );
    case dateModes.deliverySaturday:
      return (
        <DeliverySaturday {...props} />
      );
    case dateModes.deliverySunday:
      return (
        <DeliverySunday {...props} />
      );
    case dateModes.none:
    default:
      return null;
  }
};
